export const useCountryCode = () => useState<string>('countryCode', () => '');